import { Navigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth'
import { FullPageSkeleton } from '@/ui/components'

const ADMIN_EMAILS = ['admin@sitrepp.io', 'admin@sitrepp.com']

interface AdminRouteProps {
  children: React.ReactNode
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <FullPageSkeleton />
  }

  const hasStoredSession = (() => {
    try {
      return !!localStorage.getItem('access_token') && !!localStorage.getItem('refresh_token')
    } catch {
      return false
    }
  })()

  if (!user || !isAuthenticated) {
    if (hasStoredSession) {
      return <FullPageSkeleton />
    }
    return <Navigate to="/login" replace />
  }

  const isAdmin = ADMIN_EMAILS.includes(user.email?.trim().toLowerCase() ?? '')
  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
